import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import { InlineError, TEXT_MUTED } from '@internal/ui';
import { useIncidentPush, type PushState } from '../../util/webPush';

/**
 * Turns incident pushes on by itself once notifications are allowed (useIncidentPush). Mounted
 * once at the app level, so pushes start without a visit to the incidents page.
 */
export function IncidentPushAuto() {
  useIncidentPush();
  return null;
}

const HINTS: Partial<Record<PushState, string>> = {
  on: 'Tu reçois les incidents en notification système, même sans onglet du portail ouvert.',
  off: 'Active-les pour être prévenu d’un incident même sans onglet du portail ouvert.',
  denied:
    'Notifications bloquées par le navigateur : autorise-les dans les réglages du site, puis reviens ici.',
  unsupported:
    'Ce navigateur ne gère pas les notifications push (ou le portail n’est pas en https).',
  unavailable: 'Les notifications push ne sont pas disponibles sur ce portail.',
};

/** « Paramètres › Notifications »: incident pushes for this browser, on by default. */
export function IncidentPushSettings() {
  const { state, error, enable, disable } = useIncidentPush();
  const usable = state === 'on' || state === 'off';
  return (
    <Paper variant="outlined" style={{ padding: 16, marginBottom: 16 }}>
      <Typography variant="h6" style={{ fontSize: 16 }}>
        Incidents en push sur ce navigateur
      </Typography>
      <FormControlLabel
        control={
          <Switch
            color="primary"
            checked={state === 'on'}
            disabled={!usable}
            onChange={e => (e.target.checked ? enable() : disable())}
          />
        }
        label="Recevoir les incidents en push"
      />
      {state !== 'loading' && (
        <Typography variant="body2" style={{ color: TEXT_MUTED }}>
          {HINTS[state]} Le réglage vaut pour ce navigateur seulement.
        </Typography>
      )}
      {error && <InlineError message={error} />}
    </Paper>
  );
}
